import { useShareGraphicMutation } from 'api/overview';
import { Button } from 'components/ui/Button';
import { Popup } from 'components/ui/Popup';
import React from 'react';
import { useLocation } from 'react-router-dom';
import { embedQuizType, handleNativeShare } from 'utils/commonFunctions';
import {
  ICONS,
  QUIZ_TYPE_TOPICAL,
  SOCIAL_SHARING_MESSAGE,
  SOCIAL_SHARING_TITLE,
  SOCIAL_SHARING_TOPICAL_MESSAGE
} from 'utils/constants';

const SharePopup = ({ ...props }) => {
  const { state } = useLocation();
  const [share] = useShareGraphicMutation();

  const initializeSharables = async () => {
    const data = await share({
      quizId: state?.quizId,
      payload: { gamedayId: state?.GamedayId, attemptId: state?.AttemptId }
    }).unwrap();

    const url = data?.Data?.MetaPath;

    return url;
  };

  return (
    <Popup {...props} showCloseIcon>
      <Popup.Body>
        <div className='si-popup__img'>
          <img src={require('assets/images/invite.png')} />
        </div>
        <Popup.Heading>Thanks for playing!</Popup.Heading>
        <Popup.Desc>Invite your friends to have a go.</Popup.Desc>
        <div className='si-btn__wrap'>
          <Button
            onClick={async () => {
              const url = await initializeSharables();
              handleNativeShare({
                title: SOCIAL_SHARING_TITLE,
                text:
                  embedQuizType() === QUIZ_TYPE_TOPICAL
                    ? SOCIAL_SHARING_TOPICAL_MESSAGE
                    : SOCIAL_SHARING_MESSAGE,
                url: url
              });
            }}
            icon={ICONS.SHARE}
            variant={'primary'}
          >
            SHARE
          </Button>
        </div>
      </Popup.Body>
    </Popup>
  );
};

export { SharePopup };
